import React, { useState, useEffect } from "react";
import axios from "axios";
import EnviarExcel from "./EnviarExcel";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DownloadIcon from '@mui/icons-material/Download';

const ListarEncuestas = () => {
  const [encuestas, setEncuestas] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [clients, setClients] = useState([]);
  const [showEnviarExcel, setShowEnviarExcel] = useState(false);
  const [selectedEncuesta, setSelectedEncuesta] = useState(null);
  const [tipoArchivo, setTipoArchivo] = useState(null);
  const [enviosMasivos, setEnviosMasivos] = useState({});
  const [creatingEnvioByEncuesta, setCreatingEnvioByEncuesta] = useState({});
  useEffect(() => {
    if (selectedClient) {
      fetchEncuestas(selectedClient);
      fetchEnviosMasivos(selectedClient);
      return;
    }

    setEncuestas([]);
    setEnviosMasivos({});
  }, [selectedClient]);

  const fetchEnviosMasivos = async (clientId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}get_envios_masivos.php?cliente_id=${clientId}`);
      const rows = Array.isArray(response.data)
        ? response.data
        : (typeof response.data === 'string' ? JSON.parse(response.data) : []);
      const envios = {};
      rows.forEach((e) => {
        const encuestaId = Number(e.encuesta_id);
        envios[encuestaId] = {
          ...e,
          id: Number(e.id),
          encuesta_id: encuestaId,
          cliente_id: Number(e.cliente_id),
          terminado: Number(e.terminado)
        };
      });
      setEnviosMasivos(envios);
    } catch (error) {
      setEnviosMasivos({});
    }
  };

  const crearEnvioMasivo = async (encuestaId) => {
    if (!selectedClient || !encuestaId || enviosMasivos[encuestaId] || creatingEnvioByEncuesta[encuestaId]) return;

    setCreatingEnvioByEncuesta((prev) => ({ ...prev, [encuestaId]: true }));

    try {
      const formData = new FormData();
      formData.append('cliente_id', selectedClient);
      formData.append('encuesta_id', encuestaId);
      const response = await axios.post(`${process.env.REACT_APP_URL}envio_masivo.php`, formData);

      if (response.data.success) {
        setEnviosMasivos(prev => ({
          ...prev,
          [encuestaId]: {
            id: response.data.id,
            encuesta_id: encuestaId,
            cliente_id: selectedClient,
            enviados: 0,
            inicio: new Date().toISOString().split('T')[0],
            fin: null,
            terminado: 0
          }
        }));
      } else if (response.data.already_exists) {
        setEnviosMasivos(prev => ({
          ...prev,
          [encuestaId]: {
            id: Number(response.data.id),
            encuesta_id: Number(encuestaId),
            cliente_id: Number(selectedClient),
            enviados: 0,
            terminado: Number(response.data.terminado || 0)
          }
        }));
      } else {
        alert(response.data.message ? response.data.message : JSON.stringify(response.data));
      }
    } catch (error) {
      alert('Error al crear el envío masivo');
    } finally {
      setCreatingEnvioByEncuesta((prev) => ({ ...prev, [encuestaId]: false }));
      fetchEnviosMasivos(selectedClient);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}admin/get_clients.php`
    );
    setClients(response.data.clients);
  };

  const fetchEncuestas = async (clientId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}admin/listar_encuestas.php?client=${clientId}`
    );
    setEncuestas(response.data);
  };

  const handleFilterChange = (event) => {
    setSelectedClient(event.target.value);
    setSelectedEncuesta(null);
    setShowEnviarExcel(false);
    setEnviosMasivos({});
    setCreatingEnvioByEncuesta({});
  };

  const subirArchivo = (encuesta, tipo) => {
    setTipoArchivo(tipo);
    setSelectedEncuesta(encuesta);
    setShowEnviarExcel(true);
  };

  const descargarArchivo = (encuesta) => {
    window.open(`${process.env.REACT_APP_URL}admin/reportes.php?encuesta=${encuesta.id}`); 
    setSelectedEncuesta(null);
  };

  return (
    <div  className='adminelement'>
      <h2>Listar Encuestas</h2>
      <div>
        <label htmlFor="client-filter">Filtrar por Cliente: </label>
        <select id="client-filter" onChange={handleFilterChange}>
          <option value="">Seleccione un cliente</option>
          {clients.map((client) => (
            <option key={client.id} value={client.id}>
              {client.nombre}
            </option>
          ))}
        </select>
      </div>
      <ul>
  {!Array.isArray(encuestas) || encuestas.length === 0 ? (
    <li>No hay encuestas para este cliente</li>
  ) : (
    encuestas.map((encuesta) => (
      <li key={encuesta.id}>
        <strong>
          {encuesta.nombre + ' '}
        </strong>
        {/* Botón para crear envío masivo */}
        {selectedClient && enviosMasivos[encuesta.id] && enviosMasivos[encuesta.id].id ? (
          <span style={{marginLeft: '10px', color: 'green'}}>
            Envío masivo ya creado | Status: {enviosMasivos[encuesta.id].terminado === "1" || enviosMasivos[encuesta.id].terminado === 1 ? "Finalizado" : "Pendiente"}
          </span>
        ) : (
          <button
            style={{marginLeft: '10px'}}
            onClick={() => crearEnvioMasivo(encuesta.id)}
            disabled={Boolean(creatingEnvioByEncuesta[encuesta.id])}
          >
            {creatingEnvioByEncuesta[encuesta.id] ? 'Creando envío...' : 'Crear envío masivo'}
          </button>
        )}
        {/* ...existing code... */}
        {(encuesta.preguntas == false) ? (
          <button className="preguntas" onClick={() => subirArchivo(encuesta, 1)}>
            <UploadFileIcon />Subir preguntas
          </button>
        ) : ('')}
        {(encuesta.preguntasmultiples == true) ? (
          (encuesta.respuestas == false) ? (
            <button className="respuestas" onClick={() => subirArchivo(encuesta, 2)}>
              <UploadFileIcon />Subir respuestas
            </button>
          ) : (' -- ')
        ) : ('')}
        {(encuesta.preguntas == true) ? (
          (encuesta.preguntasmultiples == true) ? (
            (encuesta.respuestas == true) ? (
              <button className="descargar" onClick={() => descargarArchivo(encuesta)}>
                <DownloadIcon />Descargar resultados
              </button>
            ) : ('')
          ) : (
            <button className="descargar" onClick={() => descargarArchivo(encuesta)}>
              <DownloadIcon />Descargar resultados
            </button>
          )
        ) : ('')}
        {selectedEncuesta && selectedEncuesta.id === encuesta.id && showEnviarExcel && (
          <EnviarExcel
            encuestaId={selectedEncuesta.id}
            showEnviarExcel={() => setShowEnviarExcel(false)}
            tipo={tipoArchivo}
            fetchEncuestas={() => fetchEncuestas(selectedClient)}
          />
        )}
      </li>
    ))
  )}
</ul>

    </div>
  );
};

export default ListarEncuestas;
